import { gql } from "@apollo/client";
import Fragments from "./fragments";

export const UPDATE_USER_PROFILE = gql`
  mutation updateUserProfile($input: UserProfileInputType!) {
    updateUserProfile(input: $input) {
      ...userProfile
    }
  }
  ${Fragments.userProfile}
`;
